import { defineComponent, reactive } from 'vue';
import { useModelWrapper } from '@hems/util';
export default defineComponent({
    name: 'ReportTabList',
    props: {
        modelValue: {
            type: String,
            required: true,
            default: 'hourly',
        },
        showList: {
            type: Array,
            required: true,
        },
    },
    setup(props, { emit }) {
        const state = reactive({
            tabname: useModelWrapper(props, emit),
        });
        function switchTab(tabname) {
            state.tabname = tabname;
        }
        return { state, switchTab };
    },
});
